export default "__VITE_ASSET__5aea170c__"